import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InvoiceTable from "./InvoiceTable";
import InvoiceHeader from "./InvoiceHeader";
import InvoiceTemplate from "./InvoiceTemplate";
import NewInvoice from "./NewInvoice";
import { getInvoices } from "../../../services/invoice.services";
import { setInvoices } from "../../../state/reducers/invoiceSlice";

const Invoice = () => {
  const [viewInvoice, setViewInvoice] = useState(null); // State for viewing an invoice

  const isSideBarOpen = useSelector((state) => state.application.isSideBarOpen);
  const dispatch = useDispatch();
  const sidebarMargin = isSideBarOpen ? "ml-80" : "ml-20";
  const [isCreatingInvoice, setIsCreatingInvoice] = useState(false);

  const getAllInvoices = async () => {
    try {
      const res = await getInvoices();
      dispatch(setInvoices(res.data));
      if (viewInvoice) {
        setViewInvoice(
          res.data.filter((item) => item.id === viewInvoice.id)[0]
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleNewInvoice = () => {
    setIsCreatingInvoice(true);
  };

  const handleCloseInvoice = () => {
    setIsCreatingInvoice(false);
  };
  return (
    <div className="flex">
      {/* Sidebar (Placeholder for future implementation) */}

      {/* Main Content */}
      <div
        className={`flex-1 bg-gray-50 ${
          isSideBarOpen ? "ml-80" : "ml-0 md:ml-24"
        } min-h-screen`}
      >
        {/* Header Section */}
        {!isCreatingInvoice ? (
          <>
            <SectionWrapper>
              <InvoiceHeader
                handleNewInvoice={handleNewInvoice}
                setViewInvoice={setViewInvoice}
              />
            </SectionWrapper>

            {/* Table Section */}
            <SectionWrapper>
              <InvoiceTable
                getAllInvoices={getAllInvoices}
                setViewInvoice={setViewInvoice}
                viewInvoice={viewInvoice}
              />
            </SectionWrapper>
          </>
        ) : (
          <SectionWrapper>
            {/* <div className="w-full max-w-5xl bg-white border-2 border-purple-500 rounded-lg shadow-md p-6"> */}
            <NewInvoice
              handleCloseInvoice={handleCloseInvoice}
              getAllInvoices={getAllInvoices}
              setViewInvoice={setViewInvoice}
              viewInvoice={viewInvoice}
            />
            {/* </div> */}
          </SectionWrapper>
        )}
      </div>
    </div>
  );
};

// Reusable Section Wrapper for consistent styling
const SectionWrapper = ({ children, customPadding = "p-4" }) => {
  return (
    <div className={`${customPadding} border-b-2 border-gray-300`}>
      {children}
    </div>
  );
};

export default Invoice;
